<template>
  <div class="col-lg-12">
    <div class="row d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <span class="ml-2 label-bold color-dark-purple"> IDIOMAS </span>
      </div>
      <div>
        <button
          type="button"
          class=" f14 btn-add-items-tb bg-light-purple color-white"
          @click="showForm = !showForm"
        >
          ADICIONAR
        </button>
      </div>
    </div>

    <div
      class="mt-3"
      v-if="showForm"
    >
      <LanguageForm
        :candidate_id="candidate_id"
        :url_custom="url"
      />
    </div>

    <div v-show="this.languages.length >= 0">
      <div
        v-for="language in this.languages"
        :key="language.id"
      >
        <div class="mt-3">
          <div class="row mb-1 border-dark-purple pt-3 pb-4">
            <div class="col-lg-12">
              <div>
                <div class="d-flex justify-content-between">
                  <div class="col-lg-3 col-xs-3">
                    <span> <strong>IDIOMA:</strong> {{ language.name }} </span>
                  </div>
                  <div class="col-lg-4 col-xs-3">
                    <span>
                      <strong>NÍVEL:</strong> {{ levels[language.level].text }}
                    </span>
                  </div>
                  <div
                    style="margin-right: 10px !important"
                    class="menu_column nav nav-tabs"
                  >
                    <li
                      style="background-color: #f4f4f4 !important"
                      class="nav-item dropdown"
                    >
                      <div
                        class="nav-link"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        style="background-color: #fcfcfc"
                      >
                        <font-awesome-icon icon="ellipsis-h" />
                      </div>
                      <div class="dropdown-menu drop-down-tb">
                        <div class="dropdown-item pointer">
                          <span
                            class="mt-0 mb-0"
                            @click="deleteLanguage(language.id)"
                          >
                            DELETAR
                          </span>
                          <i class="ml-3 fas fa-trash-alt scale_1" />
                        </div>
                      </div>
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <div
        class="d-flex justify-content-center align-item-center row mb-1 border-dark-purple pt-3 pb-4"
        v-if="this.languages.length <= 0"
      >
        <h4 class="center f15 color-dark-purple">NENHUM IDIOMA INFORMADO AINDA.</h4>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageForm from "./Form.vue";
export default {
  props: ["candidate_id", "url_custom"],
  components: { LanguageForm },
  mounted() {
    this.url = `/recruiters/talent_banks/${this.candidate_id}/candidate/languages`;
    if (this.url_custom) {
      this.url = this.url_custom;
    }
    this.getLanguages();
    eventBus.$on("getLanguages", () => {
      this.getLanguages();
    });
    eventBus.$on("closeFormTb", () => {
      this.showForm = false;
    });
  },
  data: () => ({
    url: "",
    showForm: false,
    languages: [],
    levels: [
      { text: "Não informado", value: 0 },
      { text: "Básico", value: 1 },
      { text: "Intermediário", value: 2 },
      { text: "Avançado", value: 3 },
      { text: "Fluente", value: 4 },
      { text: "Nativo", value: 5 },
    ],
  }),
  methods: {
    openForm(id) {
      showForm = !showForm;
    },
    getLanguages() {
      axios.get(this.url).then((response) => {
        this.languages = response.data.languages;
      });
    },
    deleteLanguage(id) {
      let conf = confirm("Tem certeza que deseja apagar este idioma?");
      if (!conf) return;
      axios.delete(`${this.url}/${id}`).then((response) => {
        if (response.data.status) {
          this.$toast.success("Idioma excluido com sucesso!");
          this.getLanguages();
          return;
        }

        this.$toast.error("Não foi possivel excluir o idioma");
      });
    },
  },
};
</script>